import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import EventsSection from './components/EventsSection';
import TestimonialsSection from './components/TestimonialsSection';
import GuidesPreview from './components/GuidesPreview';
import FaqSection from './components/FaqSection';
import CtaBanner from './components/CtaBanner';
import ExpertsSection from './components/ExpertsSection';

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <TopicsSection />
        <EventsSection />
        <GuidesPreview />
        <ExpertsSection />
        <TestimonialsSection />
        <FaqSection />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}
